import { pxToRem } from "@/theme/spacing";
import { CARD_GAP, COLUMN_GAP, TRANSITION_MS } from "./kanban-constants";

export const ROOT_GAP = pxToRem(COLUMN_GAP);
export const CARD_STACK_GAP = pxToRem(CARD_GAP);
export const CARD_TRANSITION = `opacity ${TRANSITION_MS}ms ease-out, box-shadow ${TRANSITION_MS}ms ease-out, background ${TRANSITION_MS}ms ease-out`;
export const CARD_MIN_HEIGHT = pxToRem(120);
export const SCROLL_FADE_WIDTH = pxToRem(24);
export const SCROLL_FADE_COLOR = "rgba(15, 19, 29, 0.95)";
export const CONTAINER_HORIZONTAL_PADDING = pxToRem(20);
export const CONTAINER_BOTTOM_PADDING = pxToRem(20);
export const CONTAINER_TOP_PADDING = pxToRem(56);
export const COLUMN_BACKGROUND =
  "radial-gradient(ellipse 180px 100px at 100% 0%, rgba(102,254,193,0.04), transparent 70%), linear-gradient(180deg, rgba(255,255,255,0.035), rgba(255,255,255,0.012))";
export const COLUMN_BORDER_SHADOW = "inset 0 0 0 1px rgba(255,255,255,0.07)";
export const COLUMN_COUNT_CHIP_BACKGROUND = "rgba(255,255,255,0.05)";
export const COLUMN_COUNT_CHIP_BORDER = "inset 0 0 0 1px rgba(255,255,255,0.08)";
export const CARD_BACKGROUND_REST =
  "linear-gradient(180deg, rgba(255,255,255,0.045), rgba(255,255,255,0.018))";
export const CARD_BACKGROUND_HOVER =
  "linear-gradient(180deg, rgba(102,254,193,0.06), rgba(102,254,193,0.015))";
export const CARD_BORDER_REST = "inset 0 0 0 1px rgba(255,255,255,0.06)";
export const CARD_BORDER_HOVER = "inset 0 0 0 1px rgba(102,254,193,0.2)";
export const METADATA_BADGE_BACKGROUND = "rgba(255, 255, 255, 0.06)";
export const METADATA_TOOLTIP_BACKGROUND = "rgba(12, 16, 24, 0.98)";
export const METADATA_TOOLTIP_BORDER = "1px solid rgba(255, 255, 255, 0.08)";
export const KANBAN_METRIC_UNIT = "CARDS";
export const SCROLL_DIRECTION_VERTICAL = "vertical";
export const WEBKIT_BOX_ORIENT_VERTICAL = "vertical";
export const COMPACT_BAR_TRACK_BACKGROUND = "rgba(255,255,255,0.07)";
export const COMPACT_BAR_TRACK_SHADOW = "inset 1px 1px 4px #00000080";
export const COMPACT_BAR_FILL_BG = [
  "linear-gradient(-45deg, rgba(102,254,193,0.9), rgba(102,254,193,0.3))",
  "linear-gradient(-45deg, rgba(247,193,135,0.9), rgba(247,193,135,0.3))",
  "linear-gradient(-45deg, rgba(167,139,250,0.9), rgba(167,139,250,0.3))",
  "linear-gradient(-45deg, rgba(147,216,255,0.9), rgba(147,216,255,0.3))",
  "linear-gradient(-45deg, rgba(255,126,179,0.9), rgba(255,126,179,0.3))",
] as const;
export const COMPACT_BAR_FILL_SHADOW = [
  "3px 0px 4px rgba(102,254,193,0.4)",
  "3px 0px 4px rgba(247,193,135,0.4)",
  "3px 0px 4px rgba(167,139,250,0.4)",
  "3px 0px 4px rgba(147,216,255,0.4)",
  "3px 0px 4px rgba(255,126,179,0.4)",
] as const;
